import React, { useState, useContext } from "react";
import DatePicker from "react-datepicker";
import StatusComp from "../../common/StatusComp";
import UserAccountBeneficiary from "./UserAccountBeneficiary";
import { isLevelFourRaymondJames,isClient } from "../../common/checkClient";


const UserAccountFormComp = (props) => {

    const isLevelFourRJ = isLevelFourRaymondJames();
    const isStewardBlackdiamond = isClient('stewardblackdiamond');

    return (

        <div className="form-body">
            <div className="form-items">
                <div className="form-row">
                    <div className="form-item">
                        <div className="form-desc">
                            Update your account information.
                        </div>
                    </div>
                </div>

                {!isLevelFourRJ &&

                    <div className="form-columns">

                        <div className="form-column">

                            {props.data.status &&
                                <div className="form-item">
                                    <div className="form-item-label">Status :</div>
                                    <div className="form-item-value"><StatusComp status={props.data.status}>{props.data.statusLabel}</StatusComp></div>
                                </div>
                            }

                            <div className="form-item">
                                <label className="form-item-label" htmlFor="accountNumber">Account Number :</label>
                                <input disabled="disabled" className="form-item-value" type="text" id="accountNumber" name="accountNumber" maxLength="255" value={props.data.accountNumber} />
                            </div>

                            <div className="form-item">
                                <label className="form-item-label" htmlFor="accountName">Account Name :</label>
                                <input disabled="disabled" className="form-item-value" type="text" id="accountName" name="accountName" maxLength="255" value={props.data.accountName} />
                            </div>

                            <div className="form-item">
                                <label className={"form-item-label"} >Beneficiaries :</label>
                                <UserAccountBeneficiary beneficiaries={props.data.beneficiaries} onAdd={props.beneficiaryAdd} onRemove={props.beneficiaryRemove} onChange={props.beneficiaryChange} />
                            </div>

                            <div className="form-item">
                                <label className="form-item-label" htmlFor="accountRelation">Account Relationship :</label>
                                <input disabled="disabled" className="form-item-value" type="text" id="accountRelation" name="accountRelation" maxLength="255" value={props.data.accountRelation === 'Other' ? props.data.otherRelation : props.data.accountRelation} />
                            </div>

                            <div className="form-item">
                                <label className="form-item-label" htmlFor="accountRegistration">Account Registration :</label>
                                <input disabled="disabled" className="form-item-value" type="text" id="accountRegistration" name="accountRegistration" maxLength="255" value={props.data.accountRegistration} />
                            </div>

                            <div className="form-item">
                                <label className="form-item-label" htmlFor="accountType">Account Type :</label>
                                <input disabled="disabled" className="form-item-value" type="text" id="accountType" name="accountType" maxLength="255" value={props.data.accountType} />
                            </div>

                            <div className="form-item">
                                <label className="form-item-label" htmlFor="accountOpenDate">Open Date :</label>
                                <div className="form-item-value">
                                    <DatePicker disabled="disabled" selected={props.data.accountOpenDate} onChange={props.handleDateChange} />
                                </div>
                            </div>

                        </div>

                        <div className="form-column">

                            <div className="form-item">
                                <label className="form-item-label" htmlFor="brokerDealerId">Financial Institution :</label>
                                <input disabled="disabled" className="form-item-value" type="text" id="brokerDealerId" name="brokerDealerId" maxLength="255" value={props.data.brokerDealerId !== 'Other' ? props.data.brokerDealerName : props.data.otherBrokerDealer} />

                            </div>

                            {props.data.brokerDealerId === 'Other' &&
                                <>
                                    <div className="form-item">
                                        <label className="form-item-label" >Address :</label>
                                        <input disabled="disabled" className="form-item-value" type="text" id="otherBrokerDealerAddress" name="otherBrokerDealerAddress" maxLength="255" value={props.data.otherBrokerDealerAddress} />
                                    </div>

                                    <div className="form-item">
                                        <label className="form-item-label" >Contact Information :</label>
                                        <textarea disabled="disabled" rows="3" className="form-item-value" id="otherBrokerDealerContact" name="otherBrokerDealerContact" maxLength="1024" value={props.data.otherBrokerDealerContact} />
                                    </div>

                                </>
                            }

                            <div className="form-item">
                                <label className="form-item-label-multi-line" htmlFor="profesionallyManaged">Is this account professionally <br />managed? :</label>
                                <input disabled="disabled" className="form-item-value" type="text" id="profesionallyManaged" maxLength="255" value={props.data.professionallyManaged} />
                            </div>

                            {props.data.attachment && 
                            <div className="panel-item">
                                <div className="panel-item-label">Attachment Document :</div>
                                <div className="panel-item-value">{props.data.attachment.fileName?props.data.attachment.fileName:props.data.attachment.name}</div>
                            </div>
                            }

                        </div>

                    </div>}
                {isLevelFourRJ &&
                    <div className="form-columns">

                        <div className="form-column">

                            {props.data.status &&
                                <div className="form-item">
                                    <div className="form-item-label">Status :</div>
                                    <div className="form-item-value"><StatusComp status={props.data.status}>{props.data.statusLabel}</StatusComp></div>
                                </div>
                            }
                            <div className="form-item">
                                <label className={`form-item-label required ${props.validation.accountNumber ? "" : "warning"}`} htmlFor="accountNumber">Account Number :</label>
                                <input className="form-item-value" type="text" id="accountNumber" name="accountNumber" maxLength="255" value={props.data.accountNumber} onChange={props.handleChange} />
                            </div>

                            <div className="form-item">
                                <label className={`form-item-label required ${props.validation.accountName ? "" : "warning"}`} htmlFor="accountName">Account Name :</label>
                                <input className="form-item-value" type="text" id="accountName" name="accountName" maxLength="255" value={props.data.accountName} onChange={props.handleChange} />
                            </div>


                            <div className="form-item">
                                <label className={"form-item-label"} >Beneficiaries :</label>
                                <UserAccountBeneficiary beneficiaries={props.data.beneficiaries} onAdd={props.beneficiaryAdd} onRemove={props.beneficiaryRemove} onChange={props.beneficiaryChange} />
                            </div>

                            <div className={`form-item ${props.data.accountRelation === 'Other' ? 'mb-0-important' : ''}`}>
                                <label className={`form-item-label required ${props.validation.accountRelation ? "" : "warning"}`} htmlFor="accountRelation">Account Relationship:</label>
                                <select className="form-item-value" name="accountRelation" value={props.data.accountRelation} onChange={props.handleChange}>
                                    <option key="" value="">(Select One)</option>
                                    <option key="Self" value="Self">Self</option>
                                    <option key="Spouse" value="Spouse">Spouse</option>
                                    <option key="Joint" value="Joint">Joint</option>
                                    <option key="Non-Spouse" value="Non-Spouse">Non-Spouse</option>
                                    <option key="Partner" value="Partner">Partner</option>
                                    <option key="Child" value="Child">Child</option>
                                    <option key="Guardian" value="Guardian">Guardian</option>
                                    <option key="Trust" value="Trust">Trust</option>
                                    {isStewardBlackdiamond &&
                                        <option key="Personal Fiduciary/Authorized Agent" value="Personal Fiduciary/Authorized Agent">Personal Fiduciary/Authorized Agent</option>
                                    }
                                    <option key="Other" value="Other">Other(Please Describe)</option>
                                </select>
                            </div>
                            {props.data.accountRelation === 'Other' &&
                                <div className="form-item">
                                    <label className={`form-item-label required ${props.validation.otherRelation ? "" : "warning"}`} >Other Relationship :</label>
                                    <input className="form-item-value" type="text" id="otherRelation" name="otherRelation" maxLength="255" value={props.data.otherRelation} onChange={props.handleChange} />
                                </div>
                            }

                            <div className="form-item">
                                <label className={`form-item-label required ${props.validation.accountRegistration ? "" : "warning"}`} htmlFor="accountRegistration">Account Registration:</label>
                                <select className="form-item-value" name="accountRegistration" value={props.data.accountRegistration} onChange={props.handleChange}>
                                    <option key="" value="">(Select One)</option>
                                    <option key="Individual" value="Individual">Individual</option>
                                    <option key="Joint - Rights of Survivorship" value="Joint - Rights of Survivorship">Joint - Rights of Survivorship</option>
                                    <option key="Investment Club" value="Investment Club">Investment Club</option>
                                    <option key="Custodial Account (UTGMA/UTMA)" value="Custodial Account (UTGMA/UTMA)">Custodial Account (UTGMA/UTMA)</option>
                                    <option key="Retirement Account (401K, IRA, 403b)" value="Retirement Account (401K, IRA, 403b)">Retirement Account (401K, IRA, 403b)</option>
                                    {isStewardBlackdiamond &&
                                    <>
                                        <option key="Joint" value="Joint">Joint</option>
                                        <option key="Individual Directed Retirement Plan (IRA, Roth IRA, etc.)" value="Individual Directed Retirement Plan (IRA, Roth IRA, etc.)">Individual Directed Retirement Plan (IRA, Roth IRA, etc.)</option>
                                        <option key="Employer Directed Retirement Plan (401K,403B, etc)" value="Employer Directed Retirement Plan (401K,403B, etc)">Employer Directed Retirement Plan (401K,403B, etc)</option>
                                        <option key="Estate" value="Estate">Estate</option>
                                        <option key="Trust" value="Trust">Trust</option>
                                        <option key="529" value="529">529</option>
                                        <option key="Business Entity (LP, LLC, SP, etc.)" value="Business Entity (LP, LLC, SP, etc.)">Business Entity (LP, LLC, SP, etc.)</option>
                                    </>
                                    }
                                    <option key="Other" value="Other">Other(Please Describe)</option>
                                </select>
                            </div>
                            {props.data.accountRegistration ==='Other' &&
                                <div className="form-item">
                                    <label className={`form-item-label required ${validation.otherRegistration ? "" : "warning"}`} >Other Registration :</label>
                                    <input className="form-item-value" type="text" id="otherRegistration" name="otherRegistration" maxLength="255" value={props.data.otherRegistration} onChange={props.handleChange}/>
                                </div>
                            }

                            <div className="form-item">
                                <label className={`form-item-label required ${props.validation.accountType ? "" : "warning"}`} htmlFor="accountType">Account Type:</label>
                                <select className="form-item-value" name="accountType" value={props.data.accountType} onChange={props.handleChange}>
                                    <option key="" value="">(Select One)</option>
                                    <option key="Cash" value="Cash">Cash</option>
                                    <option key="Margin" value="Margin">Margin</option>
                                    <option key="Crypto related" value="Crypto related">Crypto related</option>
                                    
                                </select>
                            </div>

                            <div className="form-item">
                                <label className={`form-item-label required ${props.validation.accountOpenDate ? "" : "warning"}`} htmlFor="accountOpenDate">Open Date :</label>
                                <div className="form-item-value">
                                    <DatePicker selected={props.data.accountOpenDate} onChange={props.handleDateChange} />
                                </div>
                            </div>
                        </div>

                        <div className="form-column">
                            <div className="form-item">
                                <label className={`form-item-label required ${props.validation.brokerDealerId ? "" : "warning"}`} htmlFor="brokerDealerId">Your Financial Institution:</label>
                                <select className="form-item-value" name="brokerDealerId" value={props.data.brokerDealerId} onChange={props.handleChange}>
                                    <option key="" value="">(Select One)</option>
                                    {props.metadata.brokerDealer &&
                                        props.metadata.brokerDealer.map((rr) => (
                                            <option key={rr.id} value={rr.id}>
                                                {rr.name}
                                            </option>
                                        ))}

                                    {localStorage.getItem("ALLOW_UNKNOWN_BROKERDEALER") === 'true' && <option key='Other' value='Other'>Other (Please specify)</option>}

                                </select>
                            </div>
                            {props.data.brokerDealerId === 'Other' &&
                                <>
                                    <div className="form-item">
                                        <label className={`form-item-label required ${props.validation.otherBrokerDealer ? "" : "warning"}`}>Name of the Broker-Dealer Or Investment Advisor :</label>
                                        <input className="form-item-value" type="text" id="otherBrokerDealer" name="otherBrokerDealer" maxLength="255" value={props.data.otherBrokerDealer} onChange={props.handleChange} />
                                    </div>

                                    <div className="form-item">
                                        <label className="form-item-label">Address :</label>
                                        <input className="form-item-value" type="text" id="otherBrokerDealerAddress" name="otherBrokerDealerAddress" maxLength="255" value={props.data.otherBrokerDealerAddress} onChange={props.handleChange} />
                                    </div>

                                    <div className="form-item">
                                        <label className="form-item-label">Contact Information :</label>
                                        <textarea rows="3" className="form-item-value" id="otherBrokerDealerContact" name="otherBrokerDealerContact" maxLength="1024" value={props.data.otherBrokerDealerContact} onChange={props.handleChange} />
                                    </div>
                                </>
                            }
                            <div className="form-item">
                                <label className="form-item-label">Is this account professionally managed and does not allow for Self-directed transactions?</label>
                                <div className="form-item-value label-group">
                                    <label>
                                        <input type="radio" className="form-check-input" name="professionallyManaged" checked={props.data.professionallyManaged === 'N'} onChange={props.handleChange} value="N" />No
                                    </label>
                                    <label>
                                        <input type="radio" className="form-check-input" name="professionallyManaged" checked={props.data.professionallyManaged === 'Y'} onChange={props.handleChange} value="Y" />Yes
                                    </label>
                                </div>
                            </div>

                            {props.data.attachment && 
                            <div className="panel-item">
                                <div className="panel-item-label">Attachment Document :</div>
                                <div className="panel-item-value">{props.data.attachment.fileName?props.data.attachment.fileName:props.data.attachment.name}</div>
                            </div>
                            }



                        </div>

                    </div>
                }

            </div>
        </div>

    )

};



export default UserAccountFormComp;